import React from 'react';
import PropTypes from 'prop-types';


function FilterTableHeader({ filterTable }) {
  return (
    <div className="live_search">
      <span>Find What: </span>
      <input onChange={filterTable}
             placeholder="enter search term"
             type="search"
             style={{ width: 250 }} />
    </div>
  );
};

FilterTableHeader.defaultProps = {
  // className: 'filter-table',
  // premiumSearch: null,
  // showHeader: true,
  // filterTable: null,
  filterTable: () => null,
};

FilterTableHeader.propTypes = {
  // className: PropTypes.string,
  // children: PropTypes.node.isRequired,
  // premiumSearch: PropTypes.object,
  // showHeader: PropTypes.bool,
  filterTable: PropTypes.func,
};

export default FilterTableHeader;



/** WEBPACK FOOTER **
 ** ./src/components/common/FilterTableHeader.js
 **/